import { z } from 'zod';

/**
 * The task-specific READ contract for the review list: the slice of a pending
 * finding that only clinical-tasks carries, riding opaquely in the generic
 * findings response's `extras` (the shared `PendingReviewItem` stays
 * agent-agnostic). The agent's `listPending` builds it (`satisfies`) and the
 * panel parses it back with this schema — ONE definition, no drift.
 *
 * Loose strings on purpose: an unknown stored category/priority must degrade
 * in the UI (label fallback), not fail the parse.
 */
export const clinicalTaskFindingExtrasSchema = z.object({
  category: z.string().nullable(),
  priority: z.string().nullable(),
  /** ISO date (YYYY-MM-DD). */
  dueDate: z.string().nullable(),
  /** Assignee, `Practitioner/<id>`. */
  ownerReference: z.string().nullable(),
  /** Patient display name, resolved server-side off Task.for. */
  forDisplay: z.string().nullable(),
});

export type ClinicalTaskFindingExtras = z.infer<
  typeof clinicalTaskFindingExtrasSchema
>;
